<template>
	<ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
		<v-dialog v-model="showDialog" width="600" persistent>
			<v-card class="pb-3 pt-0">
				<v-card-title class="primary">
					<span class="white--text">{{ title }}</span>
				</v-card-title>
				<v-card-text class="subtitle-1 pb-0 pt-4">
					<div v-if="isInvalid">
						<p>No match found for <span class="font-weight-bold">"{{fullAddress.formatted_address}}"</span>.</p>
						<div v-if="isValidated">
							<p class="mb-1 font-weight-bold">Cannot validate address. Invalid parameter/s:</p>
							<p class="my-0" v-for="item in invalidItems" :key="item.name">{{item}}</p>
						</div>
						<p class="mt-4">Please provide the following details and notify the customer.</p>
					</div>
					<p v-else>Please provide the following details:</p>
					
					<v-row>
						<v-col v-show="isAdmin || isUserMember" cols="12" md="6" class="py-0">
							<ValidationProvider name="Customer Name" :rules="isAdmin || isUserMember ? 'required' : ''" v-slot="{ errors }">
								<v-text-field
									label="Customer Name"
									type="text"
									name="customerName"
									v-model="customerName"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col v-show="isAdmin" cols="12" md="6" class="py-0">
							<ValidationProvider name="Customer Email" :rules="isAdmin || isUserMember ? 'required|email' : ''" v-slot="{ errors }">
								<v-text-field
									label="Customer Email"
									type="text"
									name="customerEmail"
									v-model="customerEmail"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" md="6" class="py-0">
							<ValidationProvider name="Street Address" rules="required" v-slot="{ errors }">
								<v-text-field
									label="Street Address"
									type="text"
									name="streetAddress"
									v-model="streetAddress"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" md="6" class="py-0">
							<ValidationProvider name="Suburb" rules="required" v-slot="{ errors }">
								<v-text-field
									label="Suburb"
									type="text"
									name="suburb"
									v-model="suburb"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" md="6" class="py-0">
							<ValidationProvider name="State" rules="required" v-slot="{ errors }">
								<v-text-field
									label="State"
									name="state"
									v-model="state"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" md="6" class="py-0">
							<ValidationProvider name="Postcode" rules="required" v-slot="{ errors }">
								<v-text-field
									label="Postcode"
									type="text"
									name="postcode"
									v-model="postcode"
									autocomplete="new"
									:error-messages="errors"
								></v-text-field>
							</ValidationProvider>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="mt-2 mr-2">
					<v-spacer></v-spacer>
					<v-btn
						class="mr-3 primary"
						@click="isAdmin || isUserMember ? sendEmail() : createTicket()"
						:disabled="invalid || !dirty"
					>{{ buttonText }}</v-btn>
					<v-btn
						@click="closeDialog"
					>Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</ValidationObserver>
</template>

<script>
export default {
  name: "InvalidAddress",
  props: {
    showDialog: { type: Boolean, required: true },
    invalidItems: { type: Array, required: true },
    isInvalid: { type: Boolean, required: true },
    title: { type: String, required: true },
    isValidated: { type: Boolean, required: true }
  },
  data: () => ({
    streetAddress: "",
    suburb: "",
    state: "",
    postcode: "",
    customerEmail: "",
    customerName: ""
  }),
  methods: {
    sendEmail () {
      let vm = this;
      let payload = {
        to: vm.customerEmail,
        bcc: "",
        mobile: "",
        toName: vm.customerName,
        addressDetails: {
          streetAddress: vm.streetAddress,
          suburb: vm.suburb,
          state: vm.state,
          postcode: vm.postcode
        }
      };
      vm.createTemplatedEmail(payload).then(() => {
        vm.reset();
        vm.$emit("close");
      });
    },
    createTicket () {
      let vm = this;
      let payload = {
        customerName: vm.user.name,
        customerEmail: vm.user.email,
        type: 0,
        address: {
          streetAddress: vm.streetAddress,
          suburb: vm.suburb,
          state: vm.state,
          postcode: vm.postcode
        }
      };

      vm.createSupportTicket(payload).then(() => {
        vm.reset();
        vm.$emit("close");
      });
    },
    closeDialog () {
      let vm = this;
      vm.reset();
      vm.$emit("close");
    },
    reset () {
      let vm = this;
      vm.streetAddress = "";
      vm.suburb = "";
      vm.state = "";
      vm.postcode = "";
      vm.customerEmail = "";
      vm.customerName = "";
    }
  },
  computed: {
    buttonText () {
      let vm = this;
      if (vm.isAdmin) return "Send Email";
      else return "Create Support Ticket";
    }
  }
}
</script>

<style lang="scss" scoped>
</style>